// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react"

/* ==== IMPORT PAGINE / LAYOUT ================================================= */
import AdminLayout            from "./admin/AdminLayout";
import AdminDashboard         from "./admin/pages/Dashboard/AdminDashboard";
import InventoryPage          from "./admin/pages/Inventory/InventoryPage";
import RestaurantsPage        from "./admin/pages/Restaurants/RestaurantsPage";
import RestaurantDetailsPage  from "./admin/pages/Restaurants/RestaurantDetailsPage";
import OrdersPage             from "./admin/pages/Orders/OrdersPage";
import AdminUsers             from "./admin/pages/Users/AdminUsers";
import BusinessCostsPage      from "./admin/pages/Costs/BusinessCostsPage";

import ChefDashboard          from "./chef/ChefDashboard";
import WaiterDashboard        from "./waiter/WaiterDashboard";
import WaiterPOSPage          from "./waiter/WaiterPOSPage";

import AuthPage               from "./admin/pages/Auth/AuthPage";
import ProtectedRoute         from "./admin/pages/Auth/ProtectedRoute";
import SuperAdminDashboard    from "./super_admin/SuperAdminDashboard";


/* ----------------------------------------------------- */

function App() {
  return (
    <Routes>
      {/* LOGIN */}
      <Route path="/" element={<AuthPage />} />

      {/* SUPER‑ADMIN */}
      <Route
        path="/super_admin/*"
        element={
          <ProtectedRoute requiredRole="super_admin">
            <SuperAdminDashboard />
          </ProtectedRoute>
        }
      />

      {/* ADMIN AREA */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute requiredRole="admin">
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard/*" element={<AdminDashboard />} />
        <Route path="restaurants" element={<RestaurantsPage />} />
        <Route path="restaurants/:id" element={<RestaurantDetailsPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="inventory" element={<InventoryPage />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="costs" element={<BusinessCostsPage />} />
      </Route>

      {/* CHEF */}
      <Route
        path="/chef"
        element={
          <ProtectedRoute requiredRole="chef">
            <ChefDashboard />
          </ProtectedRoute>
        }
      />

      {/* WAITER */}
      <Route
        path="/waiter"
        element={
          <ProtectedRoute requiredRole="waiter">
            <WaiterDashboard />
          </ProtectedRoute>
        }
      />

      {/* POS (waiter) */}
      <Route
        path="/pos/:tableId/:sessionId"
        element={
          <ProtectedRoute requiredRole="waiter">
            <WaiterPOSPage />
          </ProtectedRoute>
        }
      />

      {/* 404 / fallback */}
      <Route path="*" element={<div>Homepage o 404</div>} />
    </Routes>
  );
}

export default App;
